import * as React from "react";

import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
// public routes
import SignUp from "pages/private/SignUp";
import SignIn from "pages/private/SignIn";
import Main from "pages/public/Main";
import Events from "pages/public/Events";
// components
import TopMenu from "components/TopMenu";
import Loading from "components/loading";
import UsersCard from "components/UsersCard";
// private routes
import PrivateRoute from "pages/private/PrivateRoute";
import Join from "pages/peasant/Join";
import Members from 'pages/secretary/Members';
import Joined from 'pages/secretary/Joined';
import Ban from 'pages/secretary/Ban';
import Treasury from 'pages/treasurer/Treasury';
// helpers
import { Roles } from 'types/Enums';
import theme from "./theme";
import { useAuth } from 'hooks/useAuth';
import Api from 'helpers/Api';
import { createVisible } from 'hooks/useLoading';

import './App.css';

// router
// https://github.com/remix-run/react-router/blob/main/docs/start/tutorial.md
// https://blog.logrocket.com/complete-guide-authentication-with-react-router-v6/

export default function App() {
  const { user, login, saveFull } = useAuth();
  const [ ready, setReady ] = React.useState<boolean>(false);
  const [ font, setFont ] = React.useState<string>('sans-serif');
  const [validAddr, setValidAddr] = React.useState<boolean>(false);
  const { visible, setVisible } = createVisible();
  const [idPars, setIdPars] = React.useState<number>(-1);

  React.useEffect(()=>{
    console.log(user);
    console.log(window.location);
    setVisible(true);
    const params = new URLSearchParams(window.location.search);
    let done = params.get('name');
    console.log(done);
    if (done) {
      const ver = Api.verify(done);
      ver.then((res)=>{
        setValidAddr(true);
      })
      ver.catch((e)=>console.log(e));
    }
    let iddone = params.get('id')
    console.log(iddone);
    if (iddone) setIdPars(Number(iddone));
    const settingString: string | null = localStorage.getItem('gfLocalSettings');
    if (settingString !== '') {
      const parsedSettingString = JSON.parse(String(settingString));
      if (parsedSettingString!==undefined && parsedSettingString!==null && parsedSettingString.hasOwnProperty('font')) setFont(parsedSettingString.font);
    }
    if (user?.token!==undefined) {
      const prom = Api.loginUPD(user);
      prom.then(({data}: any)=>{
        console.log(data);
        const { token, first_name: firstName, last_name: lastName, role, gold } = data;
        login({token, firstName, lastName, role, email: data.email, gold, login: data.login}, window.location.pathname);
        setReady(true);
        console.log('anim');
        saveFull(data);
      })
    }
    else setReady(true)
  }, [])

  return (
    <ThemeProvider theme={theme(font)}>
      <TopMenu />
      {validAddr&&<h1>E-mail подтвержден</h1>}
      <Loading visible={visible} />
      {ready&&<div className="App" style={{overflowX: 'hidden'}}>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/register" element={<SignUp />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/events/*" element={<Events id={idPars} />} />
          <Route path="/join" 
            element={ <PrivateRoute> <Join userRole = {[Roles.Stranger]}/> </PrivateRoute> }
          />
          <Route path="/members" 
            element={ <PrivateRoute> <Members userRole = {[Roles.Secretary, Roles.Treasurer]}/> </PrivateRoute> }
          />
          <Route path="/joined" 
            element={ <PrivateRoute> <Joined userRole = {[Roles.Secretary]}/> </PrivateRoute> }
          />
          <Route path="/ban" 
            element={ <PrivateRoute> <Ban userRole = {[Roles.Secretary]}/> </PrivateRoute> }
          />
          <Route path="/treasury" 
            element={ <PrivateRoute> <Treasury userRole = {[Roles.Treasurer]}/> </PrivateRoute> }
          />
        </Routes>
      </div>}
    </ThemeProvider>
  );
}
